var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 42V37.5H12V34.5H16.5V13.5H12V10.5H18.5V6H21.5V10.5H27V6H30V10.65C31.8 11.0167 33.25 11.9 34.35 13.3C35.45 14.7 36 16.2667 36 18C36 18.9333 35.8167 19.8583 35.45 20.775C35.0833 21.6917 34.55 22.5167 33.85 23.25C35.15 23.9167 36.1667 24.8583 36.9 26.075C37.6333 27.2917 38 28.6 38 30C38 32.0667 37.275 33.8333 35.825 35.3C34.375 36.7667 32.6 37.5 30.5 37.5H30V42H27V37.5H21.5V42H18.5ZM19.5 22.5H28.5C29.7667 22.5 30.8333 22.0583 31.7 21.175C32.5667 20.2917 33 19.2333 33 18C33 16.7333 32.5667 15.6667 31.7 14.8C30.8333 13.9333 29.7667 13.5 28.5 13.5H19.5V22.5ZM19.5 34.5H30.5C31.7667 34.5 32.8333 34.0583 33.7 33.175C34.5667 32.2917 35 31.2333 35 30C35 28.7333 34.5667 27.6667 33.7 26.8C32.8333 25.9333 31.7667 25.5 30.5 25.5H19.5V34.5Z",
    fill: "#0D161C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.f80156422664f983d1d31c89b57399e3.svg";
export { ForwardRef as ReactComponent };